import { DeleteJson as Delete } from '../helpers';
import { SeriesPath } from './path';

export default function DeleteEventFromSeries({
	channel,
	seriesUuid,
	eventUuid,
}: {
	channel: number;
	seriesUuid: string;
	eventUuid: string;
}) {
	return Delete<unknown, void>({
		path: SeriesPath(channel, `/${seriesUuid}/events/${eventUuid}`),
		data: {}
	});
}
